import gql from 'graphql-tag'
export default gql`
query DefinitionFormats{
  DefinitionFormats {
        id
        name
      }
    }
  `
